import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { sendHRTravelApproval } from '../../../store/apis/travelService';

function ConfirmOverlimit({ toggle, isOpen, r, id }) {
  const navigate = useNavigate();
  const { mutate } = useMutation({
    mutationFn: async payload => sendHRTravelApproval(payload),
    onSuccess: response => {
      if (response?.flag === 'True') {
        toast.success(
          response?.message || 'Booking request sent for HR approval.',
          {
            className: 'toast-success',
          },
        );
        toggle();
        navigate('/hr/booking-responsible');
      } else if (response?.flag === 'False') {
        toast.error(response?.message || 'Failed to send booking request.', {
          className: 'toast-error',
        });
        toggle();
      }
    },
  });

  const handleProceed = () => {
    const payload = {
      requestNo: id,
      revisionNo: r,
    };
    mutate(payload);
    toggle();
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Confirm Over Limit Booking</ModalHeader>
      <ModalBody>
        <div>
          Actual booking amount is more than quote Amount. HR Approval is
          required. Do you still want to proceed?
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex flex-row align-items-center w-100 gap-2">
          <Col>
            <button
              type="button"
              className="custom-btn w-100"
              onClick={() => handleProceed()}
            >
              Proceed
            </button>
          </Col>
          <Col>
            <button
              type="button"
              className="custom-danger-btn w-100"
              onClick={toggle}
            >
              Cancel
            </button>
          </Col>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmOverlimit;
